import type { Messages } from './en';

export const de: Messages = {
  "language.label": "Sprache",
  "auth.login": "Anmelden",
  "auth.signup": "Konto erstellen",
  "auth.signupTitle": "Erstelle dein Konto",
  "auth.signupLead": "Erstelle dein Konto, bestätige deine E-Mail, und dein kostenloser Test kann sofort starten.",
  "auth.loginLead": "Melde dich mit deiner E-Mail oder dem Benutzernamen an, den wir dir geschickt haben.",
  "auth.passwordChanged": "Passwort geändert. Melde dich mit deinem neuen Passwort an.",
  "auth.name": "Dein Name",
  "auth.email": "E-Mail",
  "auth.emailOrUsername": "E-Mail oder Benutzername",
  "auth.whatsapp": "WhatsApp-Nummer",
  "auth.whatsappHint": "Damit wir dich per WhatsApp erreichen können.",
  "auth.password": "Passwort",
  "auth.keepLoggedIn": "Auf diesem Gerät angemeldet bleiben",
  "auth.wait": "Bitte warten…",
  "auth.forgot": "Passwort vergessen?",
  "auth.enterName": "Gib deinen Namen ein.",
  "auth.weakPassword": "Wähle ein stärkeres Passwort: Es muss alle Punkte der Liste unter dem Passwort erfüllen.",
  "auth.deviceUnsupported": "Dieses Gerät wird nicht unterstützt.",
  "auth.loginAgain": "Bitte melde dich erneut an.",
  "auth.accountDeleted": "Dein Konto wurde gelöscht.",
  "password.rules": "Anforderungen an das Passwort",
  "password.length": "Mindestens 8 Zeichen",
  "password.upper": "Ein Großbuchstabe",
  "password.lower": "Ein Kleinbuchstabe",
  "password.number": "Eine Zahl",
  "password.done": "(erfüllt)",
  "password.missing": "(fehlt)",
  "phone.country": "Land: {name}, +{dial}",
  "phone.placeholder": "1512 3456789",
  "phone.search": "Suche dein Land",
  "phone.countries": "Länder",
  "phone.noCountry": "Kein Land gefunden",
  "reset.title": "Passwort zurücksetzen",
  "reset.sent": "Wenn {email} ein Konto hat, haben wir einen 6-stelligen Code geschickt. Gib ihn mit deinem neuen Passwort ein.",
  "reset.lead": "Gib deine E-Mail ein, und wir schicken dir einen Code.",
  "reset.code": "Code",
  "reset.newPassword": "Neues Passwort",
  "reset.save": "Neues Passwort speichern",
  "reset.send": "Code senden",
  "reset.back": "Zurück zur Anmeldung",
  "catalog.title": "In welchen Sprachen schaust du fern?",
  "catalog.lead": "Deine Sender, Filme und Serien kommen in diesen Sprachen, damit die App auf Handy und TV schnell lädt.",
  "catalog.continue": "Weiter",
  "catalog.languages": "Sprachen",
  "catalog.more": "Weitere Sprachen…",
  "catalog.international": "Auch internationale Filme und Serien",
  "catalog.internationalHint": "(ohne bestimmte Sprache, z. B. „Netflix-Filme“: macht die Liste größer)",
  "catalog.note": "Die heutigen Spiele auf der Startseite bleiben in allen Sprachen verfügbar. Du kannst das jederzeit unter Konto ändern.",
  "catalog.saving": "Wird gespeichert…",
  "catalog.chooseOne": "Wähle mindestens eine Sprache",
  "verify.title": "Bestätige deine E-Mail",
  "verify.lead": "Wir haben einen 6-stelligen Code an {email} geschickt. Gib ihn unten ein. Schau im Spam-Ordner nach, falls du ihn nicht siehst.",
  "verify.code": "Code",
  "verify.newCodeSent": "Ein neuer Code ist unterwegs.",
  "verify.checking": "Wird geprüft…",
  "verify.confirm": "Bestätigen",
  "verify.resend": "Neuen Code senden",
  "noAccess.noPlan.title": "Starte deinen kostenlosen Test",
  "noAccess.noPlan.body": "Fordere deinen kostenlosen Test an und schau alles auf diesem Gerät. Die meisten Tests starten sofort; deine Zeit läuft ab dem ersten Abspielen.",
  "noAccess.noPlan.contact": "Hallo, ich möchte IPTViva abonnieren.",
  "noAccess.pending.title": "Test angefordert",
  "noAccess.pending.body": "Wir haben deine Anfrage erhalten und schalten deinen kostenlosen Test in Kürze frei. Dieser Bildschirm öffnet die Sender, sobald er aktiv ist.",
  "noAccess.pending.contact": "Hallo, ich habe bei IPTViva einen kostenlosen Test angefordert.",
  "noAccess.used.title": "Kostenloser Test bereits genutzt",
  "noAccess.used.body": "Dieses Gerät, diese Nummer oder E-Mail hatte schon einen kostenlosen Test. Abonniere, um weiterzuschauen.",
  "noAccess.used.contact": "Hallo, ich habe meinen kostenlosen Test schon genutzt und möchte IPTViva abonnieren.",
  "noAccess.trialEnded.title": "Dein kostenloser Test ist beendet",
  "noAccess.trialEnded.body": "Wir hoffen, es hat dir gefallen. Abonniere, um weiterzuschauen: Standard für einen Bildschirm, Premium für zwei gleichzeitig.",
  "noAccess.trialEnded.contact": "Hallo, mein kostenloser Test ist beendet und ich möchte IPTViva abonnieren.",
  "noAccess.expired.title": "Dein Abo ist abgelaufen",
  "noAccess.expired.body": "Verlängere dein Abo, um weiterzuschauen.",
  "noAccess.expired.contact": "Hallo, ich möchte mein IPTViva-Abo verlängern.",
  "noAccess.sending": "Wird gesendet…",
  "noAccess.request": "Kostenlosen Test anfordern",
  "noAccess.waiting": "Warte auf Freischaltung…",
  "noAccess.contactWhatsapp": "Per WhatsApp kontaktieren",
  "noAccess.subscribeWhatsapp": "Per WhatsApp abonnieren",
  "noAccess.loggedInAs": "Angemeldet als {name}",
  "common.logOut": "Abmelden",
  "common.cancel": "Abbrechen",
  "common.back": "Zurück",
  "common.tryAgain": "Erneut versuchen",
  "delete.link": "Mein Konto löschen",
  "delete.title": "Konto löschen?",
  "delete.body": "Dein Konto und seine Daten werden endgültig gelöscht. Gib zur Bestätigung dein Passwort ein.",
  "delete.deleting": "Wird gelöscht…",
  "delete.confirm": "Konto löschen",
  "unverified.title": "Dein Zugang kann nicht geprüft werden",
  "unavailable.title": "IPTViva ist nicht verfügbar",
  "unavailable.device": "Dieses Gerät konnte nicht erkannt werden. Starte die App neu und versuche es erneut.",
  "unavailable.build": "Für diese Version ist kein Kontoserver eingerichtet (VITE_ACCOUNT_API).",
  "error.invalid-credentials": "E-Mail, Benutzername oder Passwort falsch.",
  "error.account-disabled": "Dieses Konto ist deaktiviert. Kontaktiere uns.",
  "error.trial-used-on-device": "Dieses Gerät hatte schon einen kostenlosen Test. Melde dich mit einem Abo-Konto an oder kontaktiere uns zum Abonnieren.",
  "error.trial-bound-to-other-device": "Dein kostenloser Test läuft schon auf deinem anderen Gerät. Abonniere, um auf mehr Geräten zu schauen.",
  "error.device-limit": "Dieses Konto wird schon auf allen Geräten genutzt, die sein Tarif erlaubt. Für ein neues Gerät kontaktiere den Support.",
  "error.unsupported-device": "Dieses Gerät wird nicht unterstützt.",
  "error.rate-limited": "Zu viele Versuche. Warte kurz und versuche es erneut.",
  "error.session-ended": "Deine Sitzung wurde beendet. Melde dich erneut an.",
  "error.invalid-email": "Gib eine gültige E-Mail ein.",
  "error.disposable-email": "Wegwerf-E-Mails werden nicht akzeptiert. Nutze deine normale E-Mail.",
  "error.invalid-phone": "Gib deine WhatsApp-Nummer mit Ländervorwahl ein.",
  "error.weak-password": "Wähle ein stärkeres Passwort: mindestens 8 Zeichen, mit Groß- und Kleinbuchstaben und einer Zahl.",
  "error.missing-name": "Gib deinen Namen ein.",
  "error.email-taken": "Mit dieser E-Mail gibt es schon ein Konto. Melde dich an.",
  "error.wrong-password": "Falsches Passwort.",
  "error.invalid-code": "Code falsch oder abgelaufen. Prüfe die E-Mail oder fordere einen neuen an.",
  "error.code-too-soon": "Wir haben gerade einen Code geschickt. Warte eine Minute, bevor du einen neuen anforderst.",
  "error.not-active": "Dein Konto hat keinen aktiven Tarif.",
  "error.email-unavailable": "Das Zurücksetzen per E-Mail ist noch nicht verfügbar. Schreib uns per WhatsApp, und wir schicken dir ein neues Passwort.",
  "error.invalid-input": "Wähle mindestens eine Sprache.",
  "error.server-error": "Etwas ist schiefgelaufen. Versuche es erneut.",
  "error.offline": "Keine Verbindung zum Server. Prüfe deine Internetverbindung.",
  "error.not-configured": "Der Kontoserver ist in dieser Version nicht eingerichtet.",
  "common.close": "Schließen",
  "common.dismiss": "Ausblenden",
  "common.loading": "Wird geladen…",
  "nav.main": "Hauptmenü",
  "nav.home": "Start",
  "nav.live": "Live-TV",
  "nav.movies": "Filme",
  "nav.series": "Serien",
  "nav.search": "Suche",
  "nav.account": "Konto",
  "kind.live": "Live",
  "kind.movie": "Film",
  "kind.series": "Serie",
  "tile.sports": "Live-Sport",
  "tile.movies": "Filme",
  "tile.series": "Serien",
  "tile.kids": "Kinder",
  "tile.music": "Musik",
  "tile.news": "Nachrichten",
  "tile.uhd": "4K UHD",
  "tile.docs": "Dokus",
  "tile.football": "Fußball",
  "tile.cinema": "Kino",
  "tile.cartoons": "Zeichentrick",
  "tile.concerts": "Konzerte",
  "sync.connecting": "Verbinde",
  "sync.downloading": "Liste wird heruntergeladen",
  "sync.live": "Live-Sender werden geladen",
  "sync.movie": "Filme werden geladen",
  "sync.series": "Serien werden geladen",
  "sync.saving": "Wird gespeichert",
  "sync.starting": "Startet",
  "sync.items": "{count} Einträge",
  "sync.of": "{done} von {total}",
  "sync.adding": "{name} wird geladen",
  "sync.updating": "{name} wird aktualisiert",
  "sync.importing": "{name} wird importiert",
  "sync.busy": "Die Senderliste wird noch aktualisiert. Warte, bis es fertig ist.",
  "errors.refused": "Der Anbieter hat die Anfrage abgelehnt. Prüfe, ob das Konto aktiv ist und sein Verbindungslimit nicht überschreitet.",
  "errors.notFound": "Die Adresse existiert auf dem Server nicht.",
  "errors.serverProblem": "Der Server des Anbieters meldet ein Problem. Stelle sicher, dass kein anderes Gerät dieses Konto nutzt, warte eine Minute und versuche es erneut.",
  "errors.network": "Keine Verbindung zum Server. Prüfe deine Internetverbindung.",
  "errors.timeout": "Der Server hat zu lange gebraucht. Versuche es später erneut.",
  "errors.http": "Der Server hat einen Fehler gemeldet.",
  "errors.bad-credentials": "Benutzername oder Passwort falsch.",
  "errors.account-expired": "Dieses Konto ist abgelaufen. Kontaktiere uns.",
  "errors.account-disabled": "Dieses Konto ist deaktiviert. Kontaktiere uns.",
  "errors.empty-playlist": "Die Liste enthält keine Sender oder Videos.",
  "errors.parse": "Die Liste konnte nicht gelesen werden.",
  "errors.invalid-input": "Angaben fehlen oder sind ungültig.",
  "errors.storage": "Die Daten konnten auf diesem Gerät nicht gespeichert werden. Schaffe Speicherplatz und versuche es erneut.",
  "errors.cancelled": "Abgebrochen.",
  "search.all": "Alle",
  "search.placeholder": "Sender, Filme, Serien",
  "search.tooShort": "Gib mindestens {count} Zeichen ein.",
  "search.none": "Keine Treffer",
  "search.results": "{count} Treffer",
  "filter.language": "Sprache",
  "filter.allLanguages": "Alle Sprachen",
  "filter.country": "Land",
  "filter.allCountries": "Alle Länder",
  "browse.loadingChannels": "Deine Sender werden geladen… Wenn nichts erscheint, öffne Konto und tippe auf Sender laden.",
  "browse.source": "Quelle",
  "browse.categories": "Kategorien",
  "browse.other": "Sonstige",
  "browse.recent": "Neu hinzugefügt",
  "browse.front": "Empfohlen",
  "browse.continue": "Weiterschauen",
  "browse.seeAll": "Alle anzeigen",
  "browse.previous": "Zurück",
  "browse.next": "Weiter",
  "browse.episodes": "Folgen",
  "browse.watched": "Zuletzt gesehen",
  "favorites.title": "Favoriten",
  "favorites.add": "{name} zu Favoriten hinzufügen",
  "favorites.remove": "{name} aus Favoriten entfernen",
  "series.continue": "{episode} ab {time} fortsetzen",
  "browse.allFiltered": "Alle {filter}",
  "browse.empty.live": "Hier gibt es keine Live-Sender.",
  "browse.empty.movie": "Hier gibt es keine Filme.",
  "browse.empty.series": "Hier gibt es keine Serien.",
  "browse.unfinished": "{kind} wurde nicht fertig geladen.",
  "browse.load.live": "Live-Sender laden",
  "browse.load.movie": "Filme laden",
  "browse.load.series": "Serien laden",
  "browse.loading.live": "Live-Sender werden geladen…",
  "browse.loading.movie": "Filme werden geladen…",
  "browse.loading.series": "Serien werden geladen…",
  "browse.meanwhile": "In der Zwischenzeit sind {count} Live-Sender unter Live-TV bereit.",
  "series.loading": "Folgen werden geladen…",
  "series.seasons": "Staffeln",
  "account.username": "Benutzername",
  "account.name": "Name",
  "account.plan": "Tarif",
  "account.freeTrial": "Kostenloser Test",
  "account.screens": "Bildschirme gleichzeitig",
  "account.unlimited": "Unbegrenzt",
  "account.trialEndsIn": "Test endet in",
  "account.validUntil": "Gültig bis",
  "account.trialNotStarted": "{length} · startet beim ersten Abspielen",
  "account.noEnd": "Kein Enddatum",
  "account.content": "Inhalte",
  "account.lastLoad": "Letztes Laden",
  "account.lastLoadDetail": "{total} ({waiting} Warten auf den Server, {download} Herunterladen, {storing} Speichern auf diesem Gerät)",
  "account.loading.live": "Sender werden geladen…",
  "account.loading.movie": "Filme werden geladen…",
  "account.loading.series": "Serien werden geladen…",
  "account.count.live": "{count} Sender",
  "account.count.movie": "{count} Filme",
  "account.count.series": "{count} Serien",
  "account.updateChannels": "Sender aktualisieren",
  "account.loadChannels": "Sender laden",
  "account.subscribe": "Abonnieren",
  "account.renew": "Verlängern",
  "account.subscribeMessage": "Hallo, ich möchte IPTViva abonnieren.",
  "account.renewMessage": "Hallo, ich möchte mein IPTViva-Abo verlängern.",
  "account.helpMessage": "Hallo, ich brauche Hilfe mit IPTViva.",
  "account.help": "Hilfe",
  "account.helpText": "Eine Frage, ein neues Gerät oder ein Sender, der nicht geht? Kontaktiere uns, wir antworten jeden Tag.",
  "account.appLanguage": "App-Sprache",
  "account.channelLanguages": "Sprachen der Sender",
  "account.international": "international",
  "account.saveLanguages": "Speichern und meine Liste neu laden",
  "account.languagesSaved": "Gespeichert. Deine Senderliste wird mit diesen Sprachen neu geladen.",
  "account.changeLanguages": "Sprachen ändern",
  "time.minutes": "{count} Min.",
  "time.hoursMinutes": "{hours} Std. {minutes} Min.",
  "time.days": "{count} Tage",
  "time.hour": "{count} Stunde",
  "time.hours": "{count} Stunden",
  "home.loading": "Die heutigen Spiele werden geladen…",
  "home.failed": "Die heutigen Spiele konnten nicht geladen werden. Diese Seite versucht es jede Minute erneut.",
  "home.welcome": "Willkommen",
  "home.noMatches": "Gerade laufen keine großen Fußballspiele. Sie erscheinen hier, sobald wir Sender finden, die sie zeigen und flüssig laufen.",
  "home.liveNow": "Jetzt live",
  "home.laterToday": "Später heute",
  "home.otherLeagues": "Weitere",
  "home.favouriteLeague": "{league} markieren: zuerst zeigen",
  "home.unfavouriteLeague": "{league} aus Favoriten entfernen",
  "home.browse": "Entdecken",
  "home.allChannels": "Alle Sender",
  "home.anyTime": "Jederzeit",
  "home.everyEpisode": "Alle Folgen",
  "home.todaysMatches": "Spiele heute",
  "home.slideOf": "{position} von {count}",
  "home.previousMatch": "Vorheriges Spiel",
  "home.nextMatch": "Nächstes Spiel",
  "home.football": "Fußball",
  "home.checking": "Sender werden geprüft…",
  "home.channelIn": "{count} Sender auf {language}",
  "home.channelsIn": "{count} Sender auf {language}",
  "home.moreOther": "{count} weitere in anderen Sprachen",
  "home.noChannel": "Noch kein Sender",
  "home.atKickoff": "Die Sender erscheinen zum Anpfiff, sobald sie geprüft sind",
  "home.channelsAtKickoff": "Sender zum Anpfiff",
  "home.tomorrow": "Morgen",
  "home.days": "Tage",
  "home.comingUp": "Demnächst",
  "home.seeDay": "{day} ansehen",
  "home.channelsOnMatchDay": "Sender am Spieltag",
  "home.noMatchToday": "Heute kein Spiel, nächstes {date}",
  "home.noMatchDay": "An diesem Tag kein Spiel, nächstes {date}",
  "home.noMatchesDay": "An diesem Tag keine Spiele der großen Ligen.",
  "home.noSchedule": "Der Spielplan der nächsten Tage ist noch nicht verfügbar.",
  "home.watchNow": "Jetzt ansehen",
  "home.details": "Details",
  "home.today": "Heute",
  "home.inMinutes": "in {count} Min.",
  "home.inHours": "in {count} Std.",
  "home.oneChannel": "{count} Sender",
  "home.channels": "{count} Sender",
  "home.oneLanguage": "{count} Sprache",
  "home.languages": "{count} Sprachen",
  "home.checkingLong": "Wir prüfen die Sender, die dieses Spiel zeigen. Die funktionierenden erscheinen hier in ein bis zwei Minuten.",
  "home.atKickoffLong": "Die Sender erscheinen hier zum Anpfiff, sobald geprüft ist, dass sie flüssig laufen.",
  "home.expectedOn": "Erwartet auf {name} · noch nicht geprüft",
  "home.expectedOnMore": "Erwartet auf {name} +{count} · noch nicht geprüft",
  "home.willBeOn": "Noch nicht geprüft: Diese Sender werden abspielbar, sobald geprüft ist, dass sie flüssig laufen.",
  "home.mightBeOn": "Vielleicht auf {name}",
  "home.mightBeOnMore": "Vielleicht auf {name} +{count}",
  "home.mightHave": "Könnten das Spiel zeigen: Tippe auf einen Sender, um ihn auszuprobieren.",
  "home.mightHaveShort": "Zeigt vielleicht das Spiel",
  "home.moreToTry": "Weitere Sender zum Ausprobieren",
  "home.notChecked": "Nicht geprüft",
  "home.searchMore": "Weitere suchen",
  "home.searchHint": "Nicht dabei? Suche nach den Sendern {channels}.",
  "home.searchHintClubs": "Nicht dabei? Suche nach den Vereinssendern der Teams oder dem Sender, der das Spiel zeigt.",
  "home.commentary": "Sprache des Kommentars",
  "home.playsSmoothly": "Läuft flüssig",
  "home.mayShowOther": "Zeigt evtl. ein anderes Spiel",
  "home.guessesBefore": "Das Spiel läuft auf einem der nummerierten Sender, aber wir wissen noch nicht, auf welchem. Während des Spiels helfen die Zuschauer, ihn zu finden.",
  "home.guessesLive": "Das Spiel läuft auf einem der nummerierten Sender, aber wir wissen noch nicht, auf welchem. Probier einen: Wir fragen dich, ob das Spiel dort läuft.",
  "home.confirmedByViewers": "Von Zuschauern bestätigt",
  "player.matchQuestion": "Läuft {match} auf diesem Sender?",
  "player.matchYes": "Ja",
  "player.matchNo": "Nein",
  "player.matchThanks": "Danke! Sobald genug Zuschauer zustimmen, sehen es alle.",
  "home.notConfirmed": "Nicht bestätigt: evtl. ein Jugendspiel",
  "home.watchedNow": "Läuft gerade · startet sofort",
  "clock.live": "LIVE",
  "clock.ht": "HZ",
  "clock.break": "Pause",
  "clock.penalties": "Elfmeterschießen",
  "clock.ft": "ENDE",
  "clock.paused": "Unterbrochen",
  "player.buffering": "Wird geladen…",
  "player.reconnecting": "Verbindung wird wiederhergestellt…",
  "player.paused": "Pausiert",
  "player.pausedByOtherApp": "Von einer anderen App angehalten (ein Anruf?). Tippe auf Wiedergabe, um live zu sehen.",
  "player.soundOffByOtherApp": "Der Ton ist aus, während eine andere App (ein Anruf?) ihn nutzt. Tippe, um ihn einzuschalten.",
  "player.soundOffShort": "Ton aus (ein Anruf?) · tippen zum Einschalten",
  "player.finished": "Beendet",
  "player.connecting": "Verbinde…",
  "player.queueTitle": "Dein kostenloser Test startet in",
  "player.queueNext": "Du bist als Nächstes dran.",
  "player.queuePosition": "Du bist Nummer {position} in der Warteschlange.",
  "player.queueBody": "Gerade sind alle Testplätze belegt. Die Wiedergabe startet von selbst, lass diesen Bildschirm also offen. Deine Testzeit beginnt, sobald du einen Platz bekommst.",
  "player.anyMoment": "Jeden Moment…",
  "player.uhdTitle": "4K und 8K werden auf diesem Gerät nicht unterstützt",
  "player.uhdBody": "Dieses Gerät kann kein 4K oder 8K abspielen, daher ist dieser Titel hier nicht verfügbar, und der Katalog hat keine HD-Version davon. Wechsle zu einem anderen Gerät, etwa einem neueren Fernseher, Computer oder Handy, um den ganzen Katalog zu sehen.",
  "browse.uhdHidden": "4K- und 8K-Titel sind ausgeblendet: Dieses Gerät kann sie nicht abspielen. Wechsle zu einem anderen Gerät, um den ganzen Katalog zu sehen.",
  "browse.uhdPaused": "4K- und 8K-Titel sind vorerst pausiert: Du siehst die HD-Versionen. Die TV-Apps für LG und Samsung haben weiterhin den ganzen Katalog.",
  "player.uhdPausedTitle": "4K und 8K sind vorerst pausiert",
  "player.uhdPausedBody": "4K- und 8K-Titel sind hier vorerst nicht verfügbar, und von diesem gibt es keine HD-Version. Versuch es später noch einmal oder nutze unsere TV-App für LG oder Samsung für den ganzen Katalog.",
  "player.uhdPausedSwitched": "4K ist vorerst pausiert: Die HD-Version wird abgespielt.",
  "player.uhdSwitched": "Dieses Gerät spielt kein 4K ab: Die HD-Version wird abgespielt.",
  "player.renewBody": "Verlängere es, um weiterzuschauen.",
  "player.trialEndedBody": "Wir hoffen, es hat dir gefallen. Abonniere, um weiterzuschauen.",
  "player.fullOne": "Läuft schon auf {count} Bildschirm",
  "player.full": "Läuft schon auf {count} Bildschirmen",
  "player.fullBodyOne": "Dein Tarif erlaubt einen Bildschirm gleichzeitig. Stoppe ihn, um hier zu schauen.",
  "player.fullBody": "Dein Tarif erlaubt {count} Bildschirme gleichzeitig. Stoppe einen, um hier zu schauen.",
  "player.stopAndWatch": "{device} stoppen und hier schauen",
  "player.replacedTitle": "Von einem anderen Bildschirm gestoppt",
  "player.replacedBody": "Dein Tarif erlaubt nur eine begrenzte Zahl von Bildschirmen gleichzeitig, und dieser wurde gestoppt, damit ein anderes Gerät schauen kann. Premium-Tarife erlauben zwei Bildschirme gleichzeitig.",
  "player.watchHere": "Hier schauen",
  "player.muted": "Stumm",
  "player.volumePercent": "Lautstärke {percent} %",
  "player.behindLive": "{time} hinter live. Zu live springen",
  "player.goLive": "Zu live",
  "player.prev": "Zurück",
  "player.next": "Weiter",
  "player.previous": "Vorherige",
  "player.previousChannel": "Vorheriger Sender",
  "player.nextChannel": "Nächster Sender",
  "player.previousEpisode": "Vorherige Folge",
  "player.nextEpisode": "Nächste Folge",
  "player.back10": "10 Sekunden zurück",
  "player.forward10": "10 Sekunden vor",
  "player.play": "Abspielen",
  "player.pause": "Pause",
  "player.audio": "Audio",
  "player.subtitles": "Untertitel",
  "player.info": "Info",
  "player.fullscreen": "Vollbild",
  "player.off": "Aus",
  "player.quality": "Qualität",
  "player.qualityStandard": "Standard",
  "player.qualityUnplayable": "{quality} lässt sich auf diesem Gerät nicht abspielen; zurück zur vorherigen Qualität.",
  "player.seek": "Position",
  "player.mute": "Stummschalten",
  "player.unmute": "Ton an",
  "player.volume": "Lautstärke",
  "player.upNext": "Als Nächstes: {name}",
  "player.playNext": "Nächste Folge",
  "player.watchAgain": "Nochmal ansehen",
  "playback.network": "Der Stream war nicht erreichbar. Prüfe deine Verbindung oder versuche es später.",
  "playback.stalled": "Der Stream hat aufgehört, Video zu senden.",
  "playback.no-start": "Der Stream ist nicht gestartet. Der Server ist vielleicht offline oder sehr langsam.",
  "playback.forbidden": "Der Anbieter hat diesen Stream abgelehnt. Das Konto hat vielleicht sein Verbindungslimit erreicht.",
  "playback.not-found": "Dieser Sender ist beim Anbieter nicht mehr verfügbar.",
  "playback.unsupported": "Das Format dieses Streams wird auf diesem Gerät nicht unterstützt.",
  "playback.media": "Das Video konnte nicht dekodiert werden.",
  "stats.title": "Wiedergabe-Statistik",
  "stats.engine": "Engine",
  "stats.resolution": "Auflösung",
  "stats.buffered": "Puffer",
  "stats.stalls": "Hänger",
  "stats.dropped": "Verlorene Bilder",
  "stats.reconnects": "Neuverbindungen",
  "stats.sound": "Ton",
  "stats.converted": "in AAC umgewandelt",
  "stats.convertedFrom": "von {codec} in AAC umgewandelt",
  "stats.original": "Original",
  "stats.started": "Gestartet in",
  "stats.problems": "Letzte Probleme",
  "stats.none": "keine",
};
